(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Leafwriter", [], factory);
	else if(typeof exports === 'object')
		exports["Leafwriter"] = factory();
	else
		root["Leafwriter"] = factory();
})(self, () => {
return 